export default "__VITE_ASSET__BHwdPn$d__"